export type FaqBlock =
  | { type: 'header'; title: string }
  | { type: 'item'; question: string; answer: string }

/** `# Section` = red heading; `## Question` = accordion item with answer body (markdown/HTML allowed). */
export function parseFaqMarkdown(markdown: string): FaqBlock[] {
  if (!markdown?.trim()) return []

  const blocks: FaqBlock[] = []
  let current: { question: string; answerLines: string[] } | null = null

  const flush = () => {
    if (!current) return
    blocks.push({
      type: 'item',
      question: current.question,
      answer: current.answerLines.join('\n').trim(),
    })
    current = null
  }

  for (const line of markdown.split('\n')) {
    if (line.startsWith('# ') && !line.startsWith('## ')) {
      flush()
      blocks.push({ type: 'header', title: line.slice(2).trim() })
    } else if (line.startsWith('## ')) {
      flush()
      current = { question: line.slice(3).trim(), answerLines: [] }
    } else if (current) {
      current.answerLines.push(line)
    }
  }

  flush()
  return blocks
}

export function faqBlocksHaveItems(blocks: FaqBlock[]): boolean {
  return blocks.some(b => b.type === 'item')
}
